/**
 * A file the app made, handed over: on a phone through its share sheet, to WhatsApp, the mail or
 * the drive, and on a computer as a download. «Exportar»'s spreadsheets, and the price catalogue.
 */

/**
 * A phone that can hand files of this kind to WhatsApp or the mail app. A laptop usually cannot,
 * and downloads.
 */
export function puedeCompartirArchivos(tipo = 'text/csv', nombre = 'prueba.csv'): boolean {
  try {
    return (
      typeof navigator.canShare === 'function' &&
      navigator.canShare({ files: [new File([''], nombre, { type: tipo })] })
    );
  } catch {
    return false;
  }
}

export function descargar(archivo: File) {
  const url = URL.createObjectURL(archivo);
  const a = document.createElement('a');
  a.href = url;
  a.download = archivo.name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Long enough for the browser to have started saving it.
  setTimeout(() => URL.revokeObjectURL(url), 30_000);
}
